import React from 'react';
import { AlertCircleIcon, LayersIcon } from 'lucide-react';
import { ConfidenceBadge } from './ConfidenceBadge';
import { DuplicateSet } from './DuplicateCard';
type MultiDuplicateCardProps = {
  duplicateSet: DuplicateSet;
  isSelected: boolean;
  onClick: () => void;
};
export function MultiDuplicateCard({
  duplicateSet,
  isSelected,
  onClick
}: MultiDuplicateCardProps) {
  const recordCount = duplicateSet.records.length;
  return <button onClick={onClick} className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${isSelected ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'}`} aria-pressed={isSelected} aria-label={`${recordCount} duplicate records for ${duplicateSet.primaryName}, ${duplicateSet.confidenceScore}% match confidence`} data-id="element-193">
      <div className="flex items-start gap-3" data-id="element-194">
        <ConfidenceBadge score={duplicateSet.confidenceScore} size="sm" data-id="element-195" />

        <div className="flex-1 min-w-0" data-id="element-196">
          <div className="flex items-center gap-2 mb-1" data-id="element-197">
            <LayersIcon className="w-4 h-4 text-gray-400" aria-hidden="true" data-id="element-198" />
            <span className="text-sm font-medium text-gray-900 truncate" data-id="element-199">
              {duplicateSet.primaryName}
            </span>
          </div>
          <div className="flex items-center gap-2 mb-3" data-id="element-200">
            <div className="w-4 h-4" aria-hidden="true" data-id="element-201" />
            <span className="text-sm text-gray-600" data-id="element-202">
              {recordCount} duplicate records
            </span>
          </div>

          <div className="flex items-center gap-3 text-xs" data-id="element-203">
            {duplicateSet.conflictCount > 0 && <span className="flex items-center gap-1 text-yellow-700 font-medium" data-id="element-204">
                <AlertCircleIcon className="w-3 h-3" aria-hidden="true" data-id="element-205" />
                {duplicateSet.conflictCount} conflicts
              </span>}
            <span className="text-green-700 font-medium" data-id="element-206">
              {duplicateSet.matchCount} matches
            </span>
          </div>
        </div>
      </div>
    </button>;
}